module.exports = __webpack_public_path__ + "img/andrea-snopek.e26da009.jpg";